import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { PercPipe } from '../../../../../pipes/perc.pipe';
import { User } from '../../../../../models/User';
import { ChartData } from '../../../charts/models/ChartData';

@Component({
  selector: 'app-ctr',
  templateUrl: './domain-ctr.component.html',
  styleUrls: ['./domain-ctr.component.css'],
  inputs: ['data']
})
export class DomainCtrComponent implements OnInit, OnChanges {
  @Input() domain;
  @Input() isFollowing;

  data;
  headers = [];
  adSizes = [];
  percPipe = new PercPipe();
  lineChartData: Array<ChartData> = [];

  get isFreemium(): boolean {
    return this.userService.isFreemium();
  }

  constructor(private userService: User) {}

  ngOnInit() {}

  ngOnChanges() {
    this.adSizes = JSON.parse(
      JSON.stringify(this.data['ctrDistribution']['adSizes'])
    );
    this.headers = [];
    this.headers.push({
      class: 'col-md-4 col-lg-4',
      text: 'CTR by Ad Size',
      key: 'adSize',
      tooltipkey: ''
    });
    this.headers.push({
      class: 'col-md-4 col-lg-4 text-xs-right',
      text: 'CTR with IVT',
      key: 'ctr',
      tooltipkey: '',
      format: 'percent',
      lockedInFreemium: true
    });
    this.headers.push({
      class: 'col-md-4 col-lg-4 text-xs-right',
      text: 'CTR without IVT',
      key: 'nonGivtSivtCtr',
      tooltipkey: '',
      format: 'percent',
      lockedInFreemium: true
    });
    if (this?.data?.ctrDistribution?.byMonth) {
      this.lineChartData = this?.data?.ctrDistribution?.byMonth;
      this.lineChartData.reverse();
    }
  }
}
